import Component from './OrdersList';

export default Component;
